"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _Lock = _interopRequireDefault(require("../../theme/icons/Lock"));

var _AccessTime = _interopRequireDefault(require("../../theme/icons/AccessTime"));

var S = _interopRequireWildcard(require("./styled"));

var TextField = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(TextField, _PureComponent);

  var _super = (0, _createSuper2["default"])(TextField);

  function TextField() {
    (0, _classCallCheck2["default"])(this, TextField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TextField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          InputProps = _this$props.InputProps,
          InputLabelProps = _this$props.InputLabelProps,
          multiline = _this$props.multiline,
          disabled = _this$props.disabled,
          type = _this$props.type,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["InputProps", "InputLabelProps", "multiline", "disabled", "type"]);
      return /*#__PURE__*/_react["default"].createElement(S.TextField, Object.assign({}, rest, {
        type: type,
        variant: "outlined",
        margin: "none",
        multiline: multiline,
        disabled: disabled,
        InputProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, InputProps), {}, {
          startAdornment: type === 'time' ? /*#__PURE__*/_react["default"].createElement(_AccessTime["default"], null) : InputProps.startAdornment,
          endAdornment: disabled ? /*#__PURE__*/_react["default"].createElement(_Lock["default"], null) : InputProps.endAdornment
        }),
        InputLabelProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, InputLabelProps), {}, {
          shrink: true
        })
      }));
    }
  }]);
  return TextField;
}(_react.PureComponent);

exports["default"] = TextField;
TextField.defaultProps = {
  InputProps: {},
  InputLabelProps: {},
  multiline: false,
  disabled: false,
  type: 'text'
};